import React from "react";
import { useLocation } from "react-router-dom";
import { T } from "../context/LanguageContext";

type RoleToggleProps = {
  options: string[];
  active: string;
  onChange: (value: string) => void;
  onDoubleClick?: (value: string) => void;
  activeClassName?: string;   // optional override
  inactiveClassName?: string; // optional override
  containerClassName?: string; // optional override for parent div
  translateOptions?: boolean;
};

const RoleToggle: React.FC<RoleToggleProps> = ({
  options,
  active,
  onChange,
  onDoubleClick,
  activeClassName = "bg-[#FBD037] text-[#131327] font-bold shadow-sm", // default values
  inactiveClassName = "bg-transparent text-[#212121]/70 font-bold",
  containerClassName = "inline-flex rounded-t-lg rounded-tr-[20px]  bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 py-0.5 px-1 space-x-2 overflow-x-auto hide-scrollbar max-w-full",
  translateOptions = true,
}) => {
  const location = useLocation();

  const handleClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    option: string
  ) => {
    // Allow Ctrl+Click or Cmd+Click to open in new tab
    if (e.metaKey || e.ctrlKey) return;

    e.preventDefault();
    onChange(option);
  };

  return (
    <div className={containerClassName} role="group">
       <div className="absolute inset-0 rounded-[inherit] bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
      {options.map((option) => {
        const href = `${location.pathname}?tab=${encodeURIComponent(option)}`;
        return (
          <a
            key={option}
            href={href} // 👈 real link → right-click "open in new tab" works
            onClick={(e) => handleClick(e, option)}
            onDoubleClick={(e) => {
              e.preventDefault();
              onDoubleClick?.(option);
            }}
            className={`px-4 py-2 text-sm rounded-lg whitespace-nowrap transition-colors duration-200 ${active === option ? activeClassName : inactiveClassName
              }`}
          >
            {translateOptions ? <T>{option}</T> : option}
          </a>
        );
      })}
    </div>
  );
};

export default RoleToggle;
